<div *ngIf="isExperimentalImplementation else antDesignImplementation">
  <ng-container *ngIf="isMobileView else desktopView">
    <phx-dialog [phxOpen]="dialogOpen">
      <div class="mobile-content" [class.mobile-content-with-footer]="isFooterShown">
        <div class="menu-header-mobile border-bottom-1 border-grey-5">
          <div class="h-100 w-100 d-flex flex-row align-items-center">
            <a (click)="handleMobileViewBackClick()">
              <i nz-icon><svg   width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.621 5.5l-3.75 3.75h11.44v1.5H5.87l3.75 3.75-1.06 1.06L3 10l5.56-5.56L9.622 5.5z" fill="#2E2E2E"/></svg></i>
            </a>
            <span *ngIf="(activeRootOption$ | async) else goBack" class="bold ml-8 overflow-ellipsis" 
              phx-tooltip [phxContent]="(activeRootOption$ | async).label" tooltipOnTruncate>
              {{ (activeRootOption$ | async).label }}
            </span>
            <ng-template #goBack>
              <span class="bold ml-8 overflow-ellipsis" i18n>Groups</span>
            </ng-template>
          </div>
        </div>
        <ng-container *ngTemplateOutlet="searchableList; context:{ mobileContent: true }"></ng-container>
      </div>
    </phx-dialog>
  </ng-container>

  <ng-template #desktopView>
    <div
      [ngClass]="{ 'w-100-imp': fullWidth }" 
      class="tooltip-wrapper" 
      phx-tooltip [phxContent]="disabledTooltipMessage" phxPlacement="topLeft" [phxTrigger]="isDisabled ? 'hover' : 'focus'"
    >
      <div
        #dropdownTriggerRef
        role="button"
        [phxDropdownFor]="experimentalMenu" phxTrigger="click" [phxVisible]="isDropDownMenuOpen" [phxClickHide]="false" [phxDisabled]="isDisabled"
        (phxVisibleChange)="onDropDownMenuVisibilityChange($event)"
      >
        <ng-container
          *ngIf="customTriggerButtonTemplate" 
          [ngTemplateOutlet]="customTriggerButtonTemplate" 
          [ngTemplateOutletContext]=" { 
            $implicit: {
            isOpen: isDropDownMenuOpen, 
            selectedCount: (independentSelectedOptions$ | async).size,
            label: buttonText
            }
          }"
        >
        </ng-container>
        <button *ngIf="!customTriggerButtonTemplate;" class="dropdown-btn ant-btn d-flex flex-row"
          [ngClass]="{
          'prefix-icon-only': prefixIconOnly,
          'selected': (independentSelectedOptions$ | async).size > 0,
          'active': isDropDownMenuOpen,
          'grey-30-imp': isDropDownMenuOpen && !(independentSelectedOptions$ | async).size,
          'w-100': fullWidth,
          'form-variant': formVariant,
          'small': isSmall,
          'regular-12': isSmall,
          'regular-14': !isSmall,
          'isDisabled': isDisabled
          }" 
        >
          <span *ngIf="prefixIconTemplate" class="prefix-icon" [ngClass]="{ 'mr-8': !prefixIconOnly, 'flex-1': prefixIconOnly }">
            <ng-container [ngTemplateOutlet]="prefixIconTemplate"></ng-container>
          </span>
          <ng-container *ngIf="!prefixIconOnly">
            <div class="d-flex justify-start min-w-0">
              <span phx-tooltip [phxContent]="buttonText" phxPlacement="topLeft" tooltipOnTruncate class="d-block float-left overflow-ellipsis" [class.align-self-center]="isSmall">{{ buttonText }}</span>
              <div #badge="phxTooltip"
                *ngIf="(independentSelectedOptions$ | async).size > (alwaysShowCondensedMessage ? 0 : 1)" 
                phx-tooltip [phxContent]="selectedOptionsTooltip" class="d-inline badge ml-8 text-center"
                [ngClass]="{ 'regular-10': isSmall, 'regular-12': !isSmall }"
              >{{(independentSelectedOptions$ | async).size }}</div>
            </div>
            <svg *ngIf="showSuffixIcon"  class="suffix-icon d-inline-block float-right ml-8" [class.align-self-center]="isSmall"  width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 13.243l4.95-4.95.707.707L10 14.657 4.343 9l.707-.707 4.95 4.95z" fill="#757575"/></svg>
          </ng-container>
        </button>
      </div>
    </div>
  </ng-template>

  <phx-dropdown #experimentalMenu>
    <div class="hierarchy-multi-select-with-counter mt-4" [ngStyle]="{
      'min-width': dropdownWidthOverride,
      'max-width': dropdownWidthOverride
    }">
      <ng-container *ngIf="(activeRootOption$ | async)">
        <div class="menu-header pl-12-imp pr-12-imp">
          <div class="h-100 w-100 border-bottom-1 border-grey-5 d-flex flex-row align-items-center">
            <a (click)="ascend()">
              <i nz-icon><svg   width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.621 5.5l-3.75 3.75h11.44v1.5H5.87l3.75 3.75-1.06 1.06L3 10l5.56-5.56L9.622 5.5z" fill="#2E2E2E"/></svg></i>
            </a>
            <span class="bold ml-8 overflow-ellipsis" phx-tooltip [phxContent]="(activeRootOption$ | async).label" tooltipOnTruncate>
              {{ (activeRootOption$ | async).label }}
            </span>
          </div>
        </div>
      </ng-container>
      <ng-container *ngTemplateOutlet="searchableList"></ng-container>
    </div>
  </phx-dropdown>

  <ng-template #searchableList let-mobileContent="mobileContent">
    <ng-container *ngIf="!(activeRootOption$ | async) && canSearchOptions">
      <div class="pb-5-imp">
        <phx-input-group  [phxSuffix]="suffixTemplate" [phxPrefix]="prefixIconSearch">
          <input #searchInput class="border-none" phxInputStyle="borderless" type="text" phx-input [ngModel]="search$ | async"
            (ngModelChange)="searchChanged($event)" placeholder="Search" i18n-placeholder
          />
        </phx-input-group>
        <hr class="border-bottom-1 border-grey-5 border-top-0 mt-0 mb-0" [ngClass]="{ 'ml-12-imp mr-12-imp': !mobileContent }" />
      </div>

      <ng-template #prefixIconSearch>
        <svg class="search-icon"    width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.582 12.874l4.99 4.99-.708.707-4.99-4.99a6 6 0 1 1 .707-.707zM8 14A5 5 0 1 0 8 4a5 5 0 0 0 0 10z" fill="#0073E7"/></svg>
      </ng-template>
      <ng-template #suffixTemplate>
        <svg *ngIf="search$ | async" class="cross-icon"  (click)="searchChanged('')"   width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.793 10.5l-4.95-4.95.707-.707 4.95 4.95 4.95-4.95.707.707-4.95 4.95 4.95 4.95-.707.707-4.95-4.95-4.95 4.95-.707-.707 4.95-4.95z" fill="#757575"/></svg>
      </ng-template>
    </ng-container>

    <div [hidden]="!isLoading" class="loading-list xy-center flex-col pt-24 pb-24">
      <i nz-icon nzType="loading" class="loading-icon"></i>
    </div>

    <phx-list class="multi-select-list" [hidden]="isLoading || activeOptions.length === 0" selection="multiple">
      <phx-list-item *ngFor="let option of activeOptions; let i = index" [selected]="(selectedOptions$ | async).has(option)"
        [indeterminate]="indeterminateOptions.has(option)" (toggleSelection)="selectOption(option)">
        <span color="secondary" phx-text-line>
          <ng-container *ngTemplateOutlet="optionLabel; context: { option: option, search$: search$ }"></ng-container>
        </span>
        <button *ngIf="!(search$ | async) && option.children && option.children.length > 0" phx-list-action (click)="descend(option)">
          <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="M12.244 10l-4.95-4.95.708-.706L13.658 10l-5.656 5.657-.708-.708 4.95-4.95z" fill="#757575" fill-rule="evenodd"></path></svg>
        </button>
      </phx-list-item>
    </phx-list>

    <div [hidden]="isLoading || activeOptions.length > 0" class="no-results-wrapper">
      <ng-template [ngTemplateOutlet]="noResultsMessageTemplate || defaultNoResultsMessageTemplate"></ng-template>
    </div>

    <div
      *ngIf="isFooterShown"
      class="footer w-100 pt-8">
      <label class="w-100">
        <span class="regular-14" i18n>{{ (independentSelectedOptions$ | async).size }} Selected</span>
        <span class="bullet pos-relative"><svg    width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" fill="#C7C7C7"/></svg></span>
        <a (click)="clear()" i18n>Clear</a>
      </label>
    </div>
  </ng-template>
</div>

<ng-template #antDesignImplementation>
  <div [ngClass]="{ 'w-100-imp': fullWidth }" class="tooltip-wrapper" phx-tooltip [phxContent]="disabledTooltipMessage" phxPlacement="topLeft" [phxTrigger]="isDisabled ? 'hover' : 'click'">
    <button #dropdownTriggerRef nz-dropdown nzTrigger="click" class="dropdown-btn ant-btn d-flex flex-row"
    [nzOverlayClassName]="overlayClassName"
    [ngClass]="{
    'prefix-icon-only': prefixIconOnly,
    'selected': (independentSelectedOptions$ | async).size > 0,
    'active': isDropDownMenuOpen,
    'grey-30-imp': isDropDownMenuOpen && !(independentSelectedOptions$ | async).size,
    'w-100': fullWidth,
    'form-variant': formVariant,
    'small': isSmall,
    'regular-12': isSmall,
    'regular-14': !isSmall,
    'isDisabled': isDisabled
  }" [nzVisible]="isDropDownMenuOpen" [nzClickHide]="false" [nzDropdownMenu]="menu" [nzDisabled]="isDisabled"
    (nzVisibleChange)="onDropDownMenuVisibilityChange($event)">
    <span *ngIf="prefixIconTemplate" class="prefix-icon" [ngClass]="{ 'mr-8': !prefixIconOnly, 'flex-1': prefixIconOnly }">
      <ng-container [ngTemplateOutlet]="prefixIconTemplate"></ng-container>
    </span>
    <ng-container *ngIf="!prefixIconOnly">
      <div class="d-flex justify-start min-w-0">
        <span phx-tooltip [phxContent]="buttonText" phxPlacement="topLeft" tooltipOnTruncate class="d-block float-left overflow-ellipsis" [class.align-self-center]="isSmall">{{ buttonText }}</span>
        <div #badge="phxTooltip"
          *ngIf="(independentSelectedOptions$ | async).size > (alwaysShowCondensedMessage ? 0 : 1)" phx-tooltip
          [phxContent]="selectedOptionsTooltip" phxPlacement="top" class="d-inline badge ml-8 text-center"
          [ngClass]="{ 'regular-10': isSmall, 'regular-12': !isSmall }"
        >{{(independentSelectedOptions$ | async).size }}</div>
      </div>
      <svg *ngIf="showSuffixIcon"  class="suffix-icon d-inline-block float-right ml-8" [class.align-self-center]="isSmall"  width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 13.243l4.95-4.95.707.707L10 14.657 4.343 9l.707-.707 4.95 4.95z" fill="#757575"/></svg>
    </ng-container>
  </button>   
  </div>
</ng-template>

<nz-dropdown-menu #menu="nzDropdownMenu">
  <div class="hierarchy-multi-select-with-counter" nz-menu [ngStyle]="{
    'min-width': dropdownWidthOverride,
    'max-width': dropdownWidthOverride
  }">
    <ng-container *ngIf="(activeRootOption$ | async)">
      <div class="menu-header pl-12-imp pr-12-imp">
        <div class="h-100 w-100 border-bottom-1 border-grey-5 d-flex flex-row align-items-center">
          <a (click)="ascend()">
            <i nz-icon><svg   width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.621 5.5l-3.75 3.75h11.44v1.5H5.87l3.75 3.75-1.06 1.06L3 10l5.56-5.56L9.622 5.5z" fill="#2E2E2E"/></svg></i>
          </a>
          <span class="bold ml-8 overflow-ellipsis" phx-tooltip [phxContent]="(activeRootOption$ | async).label" phxPlacement="top" tooltipOnTruncate>{{ (activeRootOption$ | async).label }}</span>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!(activeRootOption$ | async) && canSearchOptions">
      <div class="pl-12-imp pr-12-imp pb-5-imp phx-styled-search-input">
        <nz-input-group class="border-bottom-1 border-grey-5" [nzSuffix]="suffixTemplate" [nzPrefix]="prefixIconSearch">
          <input #searchInput class="border-none" type="text" nz-input [ngModel]="search$ | async"
            (ngModelChange)="searchChanged($event)" placeholder="Search" i18n-placeholder
          />
        </nz-input-group>
      </div>

      <ng-template #prefixIconSearch>
        <svg class="search-icon"    width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.582 12.874l4.99 4.99-.708.707-4.99-4.99a6 6 0 1 1 .707-.707zM8 14A5 5 0 1 0 8 4a5 5 0 0 0 0 10z" fill="#0073E7"/></svg>
      </ng-template>
      <ng-template #suffixTemplate>
        <svg *ngIf="search$ | async" class="cross-icon"  (click)="searchChanged('')"   width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.793 10.5l-4.95-4.95.707-.707 4.95 4.95 4.95-4.95.707.707-4.95 4.95 4.95 4.95-.707.707-4.95-4.95-4.95 4.95-.707-.707 4.95-4.95z" fill="#757575"/></svg>
      </ng-template>
    </ng-container>

    <div [hidden]="!isLoading" class="loading-list xy-center flex-col pt-24 pb-24">
      <i nz-icon nzType="loading" class="loading-icon"></i>
    </div>

    <ul
      [ngStyle]="{'max-height': overrideDropdownListMaxHeight}"
      [hidden]="isLoading || activeOptions.length === 0"
    >
      <li *ngFor="let option of activeOptions; let i = index" class="pt-8" [class.option-header]="option.isHeader" nz-menu-item>

        <ng-container *ngIf="option.isHeader else radioOrCheckboxLabel">
          <label class="simple-label">{{option.label}}</label>

          <ul *ngIf="option.children?.length" [class.d-none]="search$.getValue()">
            <li *ngFor="let subOption of option.children" class="pt-8 pl-12-imp" nz-menu-item>
              <ng-container *ngTemplateOutlet="optionWithChevron; context: { option: subOption, search$: search$ }"></ng-container>
            </li>
          </ul>
        </ng-container>

        <ng-template #radioOrCheckboxLabel>
          <ng-container *ngTemplateOutlet="optionWithChevron; context: { option: option, search$: search$ }"></ng-container>
        </ng-template>
        <hr *ngIf="option.isHeader && !search$.getValue()"/>
      </li>
    </ul>

    <div [hidden]="isLoading || activeOptions.length > 0" class="no-results-wrapper">
      <ng-template [ngTemplateOutlet]="noResultsMessageTemplate || defaultNoResultsMessageTemplate"></ng-template>
    </div>

    <div
      *ngIf="(independentSelectedOptions$ | async).size >= footerThreshold && !(activeRootOption$ | async) && !(search$ | async)"
      nz-menu-item class="footer pos-relative w-100 pt-8">
      <label class="w-100">
        <span class="regular-14" i18n>{{ (independentSelectedOptions$ | async).size }} Selected</span>
        <span class="bullet pos-relative"><svg    width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" fill="#C7C7C7"/></svg></span>
        <a (click)="clear()" i18n>Clear</a>
      </label>
    </div>
  </div>
</nz-dropdown-menu>

<ng-template #optionWithChevron let-option="option" let-search$="search$">
  <ng-container *ngIf="(option.areChildrenSingleSelect) || !isRadioSelectionEnabled">
    <ng-container *ngTemplateOutlet="checkboxLabel; context: { option: option, search$: search$ }"></ng-container>
  </ng-container>

  <ng-container *ngIf="isRadioSelectionEnabled && (!option.areChildrenSingleSelect)">
    <ng-container *ngTemplateOutlet="radioLabel; context: { option: option, search$: search$ }"></ng-container>
  </ng-container>

  <ng-container *ngIf="!(search$ | async) && option.children && option.children.length > 0">
    <nz-divider nzType="vertical"></nz-divider>
    <div class="chevron" (click)="descend(option)">
      <i nz-icon><svg   width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.244 10l-4.95-4.95.708-.706L13.658 10l-5.656 5.657-.708-.708 4.95-4.95z" fill="#757575"/></svg></i>
    </div>
  </ng-container>
</ng-template>

<ng-template #checkboxLabel let-option="option" let-search$="search$">
  <label nz-checkbox ngDefaultControl
    [ngModel]="(selectedOptions$ | async).has(option)"
    [nzDisabled]="option.disabled"
    (ngModelChange)="selectOption(option)"
    [ngClass]="{
      'chk-indeterminate': indeterminateOptions.has(option),
      'pl-12': search$.getValue(),
      'w-100-imp': (search$ | async) || !option.children || !option.children.length,
      'phx-styled-selected-option': (selectedOptions$ | async).has(option)
    }"
  >
    <ng-container *ngTemplateOutlet="optionLabel; context: { option: option, search$: search$ }"></ng-container>
  </label>
</ng-template>

<ng-template #radioLabel let-option="option" let-search$="search$">
  <label nz-radio ngDefaultControl
    [ngModel]="(selectedOptions$ | async).has(option)"
    [nzDisabled]="option.disabled"
    (ngModelChange)="selectOption(option)"
    [ngClass]="{
      'chk-indeterminate': indeterminateOptions.has(option),
      'pl-12': search$.getValue(),
      'hide-icon': hideRadioIcon,
      'w-100-imp': (search$ | async) || !option.children || !option.children.length
    }"
  >
    <ng-container *ngTemplateOutlet="optionLabel; context: { option: option, search$: search$ }"></ng-container>
  </label>
</ng-template>

<ng-template #defaultNoResultsMessageTemplate>
  <span i18n>No results found</span>
</ng-template>

<ng-template #optionLabel let-option="option" let-search$="search$">
  <ng-container *ngTemplateOutlet="!(search$ | async) ? nonSearchResult : searchResult; context:{ option: option}"></ng-container>

  <ng-template #nonSearchResult>
    <span class="grey-60 d-flex flex-1 min-w-0">
      <ng-container *ngIf="isExperimentalImplementation else noSearchText">
        <span phx-tooltip [phxContent]="option.label" tooltipOnTruncate class="overflow-ellipsis">{{ option.label }}</span>
      </ng-container>
      <ng-template #noSearchText>
        <span phx-tooltip [phxContent]="option.label" phxPlacement="top" tooltipOnTruncate class="overflow-ellipsis">{{ option.label }}</span>
      </ng-template>

    </span>
  </ng-template>
</ng-template>

<ng-template #searchResult let-option="option">
  <div truncate-breadcrumb class="w-100 d-flex">
    <div class="w-100 d-flex">
      <ng-container *ngIf="isExperimentalImplementation else searchText">
        <div class="d-flex">
          <div *ngFor="let ancestor of ancestors.get(option)" class="d-flex">
            <span class="crumb-title">{{ ancestor.label }}</span>
            <span phx-tooltip [phxContent]="ancestor.label" class="crumb-truncated">...</span>
            <span><i nz-icon><svg   width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.41 10.793L9.203 8 6.41 5.207l.707-.707 3.5 3.5-3.5 3.5-.707-.707z" fill="#757575"/></svg></i></span>
          </div>
        </div>
        <div class="search-text" [innerHTML]="option.label | highlightString:(search$ | async)" phx-tooltip [phxContent]="option.label" tooltipOnTruncate></div>
      </ng-container>
      <ng-template #searchText>
        <div class="d-flex">
          <div *ngFor="let ancestor of ancestors.get(option)" class="d-flex">
            <span class="crumb-title">{{ ancestor.label }}</span>
            <span phx-tooltip [phxContent]="ancestor.label" class="crumb-truncated">...</span>
            <span><i nz-icon><svg   width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.41 10.793L9.203 8 6.41 5.207l.707-.707 3.5 3.5-3.5 3.5-.707-.707z" fill="#757575"/></svg></i></span>
          </div>
        </div>
        <div class="search-text" [innerHTML]="option.label | highlightString:(search$ | async)" phx-tooltip [phxContent]="option.label" phxPlacement="top" tooltipOnTruncate></div>
      </ng-template>
    </div>
  </div>
</ng-template>
